'use client'
import {
  context_default
} from "./chunk-2HWJLKTQ.mjs";

// src/context/root/useSubscription.ts
import { useContext } from "react";
var defaultContext = {
  slug: "",
  active: false,
  selectedPlan: void 0,
  terms: {
    agree: false,
    recurring: false
  },
  setPlan: () => {
  },
  setTerms: () => {
  },
  clear: () => {
  }
};
var useSubscription = () => {
  const context = useContext(context_default);
  return context || defaultContext;
};

export {
  useSubscription
};
//# sourceMappingURL=chunk-NAUELPNF.mjs.map